import styled from "styled-components";
import { MapPin, EnvelopeSimple, Phone, WhatsappLogo } from "@phosphor-icons/react";

import Reveal from "./Shared/Reveal";
import { Container, Section, Eyebrow, H2 } from "./Shared/ui";

const MAP_SRC =
  "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3904.4779539649485!2d75.36029301525566!3d11.871770391583992!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba43d4a5a5aeb57%3A0xa6d86351cc7d00f9!2sVINAYAKA%20FOUNDATION!5e0!3m2!1sen!2sin!4v1608140462530!5m2!1sen!2sin";

const DETAILS = [
  {
    icon: MapPin,
    label: "Location",
    value: (
      <>
        Vinayaka Foundation, Mascot Square,
        <br />
        Nr. S.N. Park, Kannur 670001, Kerala, India
      </>
    ),
  },
  {
    icon: EnvelopeSimple,
    label: "Email",
    value: <a href="mailto:foundationvinayaka@gmail.com">foundationvinayaka@gmail.com</a>,
  },
  {
    icon: Phone,
    label: "Call",
    value: <a href="tel:+917907300686">+91 79073 00686</a>,
  },
  {
    icon: WhatsappLogo,
    label: "WhatsApp",
    value: <a href="https://wa.me/917907300686" target="_blank" rel="noreferrer">+91 79073 00686</a>,
  },
];

const ContactUs = () => {
  return (
    <Section id="contact">
      <Container>
        <Layout>
          <div>
            <Reveal>
              <Eyebrow>Contact</Eyebrow>
              <H2>Visit or call us</H2>
              <Intro>Our office in Kannur is happy to help with registration, verification and premium membership.</Intro>
            </Reveal>

            <List>
              {DETAILS.map(({ icon: Icon, label, value }, i) => (
                <Reveal as="li" key={label} index={i + 1}>
                  <IconWrap>
                    <Icon size={22} weight="duotone" />
                  </IconWrap>
                  <div>
                    <span className="label">{label}</span>
                    <span className="value">{value}</span>
                  </div>
                </Reveal>
              ))}
            </List>
          </div>

          <Reveal index={1} style={{ display: "flex" }}>
          <MapWrap>
            <iframe
              title="Map showing Vinayaka Foundation, Kannur"
              src={MAP_SRC}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
            />
          </MapWrap>
          </Reveal>
        </Layout>
      </Container>
    </Section>
  );
};

const Layout = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  gap: clamp(32px, 5vw, 72px);
  align-items: stretch;

  @media (max-width: 900px) {
    grid-template-columns: 1fr;
  }
`;

const Intro = styled.p`
  color: var(--text-muted);
  max-width: 44ch;
`;

const List = styled.ul`
  margin: 32px 0 0;
  padding: 0;
  display: grid;
  gap: 22px;

  li {
    list-style: none;
    display: flex;
    gap: 16px;
    align-items: flex-start;
  }

  .label {
    display: block;
    font-size: 14px;
    font-weight: 600;
    color: var(--text-muted);
  }

  .value {
    display: block;
    margin: 2px 0 0;
    font-weight: 600;
    font-size: 17px;
    line-height: 1.5;
    overflow-wrap: anywhere;
  }

  .value a {
    text-decoration: none;
    background-image: linear-gradient(var(--coral), var(--coral));
    background-size: 0% 2px;
    background-position: 0 100%;
    background-repeat: no-repeat;
    transition: background-size 0.4s var(--ease-out);
  }

  .value a:hover {
    background-size: 100% 2px;
  }
`;

const IconWrap = styled.span`
  flex: none;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background: var(--surface-tint);
  border: 1px solid var(--border);
  color: var(--coral);
`;

const MapWrap = styled.div`
  flex: 1;
  min-height: 360px;
  border-radius: var(--radius-card);
  overflow: hidden;
  border: 1px solid var(--border);
  box-shadow: var(--shadow);
  background: var(--surface-tint);

  iframe {
    display: block;
    width: 100%;
    height: 100%;
    min-height: 360px;
    border: 0;
  }
`;

export default ContactUs;
